import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "sonner";
import { Mail, Lock, Shield } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, editor.");
      nav("/admin");
    } catch { toast.error("Invalid credentials."); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--io-bg)] intel-grid px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="flex items-center justify-center w-10 h-10 rounded-md border border-[var(--io-gold)]/40 bg-gradient-to-br from-[var(--io-gold)]/15 to-transparent">
              <span className="font-serif text-[18px] text-[var(--io-gold)]">iO</span>
            </span>
            <span className="font-serif text-[28px] text-[var(--io-text)]">India<span className="text-[var(--io-gold)]">ODR</span></span>
          </div>
          <div className="eyebrow">Intelligence Command Center</div>
        </div>

        <div className="io-card-el p-8">
          <div className="flex items-center gap-2 mb-5">
            <Shield size={14} className="text-[var(--io-gold)]"/>
            <span className="eyebrow">Editorial Access</span>
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="kicker">Email</label>
              <div className="mt-2 flex items-center gap-2 border border-[var(--io-border)] focus-within:border-[var(--io-gold)] bg-[var(--io-bg-2)] rounded-md px-3">
                <Mail size={14} className="text-[var(--io-muted)]"/>
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 bg-transparent py-2.5 text-[14px] outline-none text-[var(--io-text)]"
                  data-testid="admin-email-input"/>
              </div>
            </div>
            <div>
              <label className="kicker">Password</label>
              <div className="mt-2 flex items-center gap-2 border border-[var(--io-border)] focus-within:border-[var(--io-gold)] bg-[var(--io-bg-2)] rounded-md px-3">
                <Lock size={14} className="text-[var(--io-muted)]"/>
                <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  className="flex-1 bg-transparent py-2.5 text-[14px] outline-none text-[var(--io-text)]"
                  data-testid="admin-password-input"/>
              </div>
            </div>
            <button disabled={loading} className="btn btn-primary w-full justify-center mt-2" data-testid="admin-login-submit">
              {loading ? "Signing in…" : "Sign in to Command Center"}
            </button>
          </form>
          <p className="mt-5 text-[11px] font-mono text-[var(--io-muted)] text-center">Editorial access only. All login attempts are logged.</p>
        </div>
      </div>
    </div>
  );
}
